import { HIDE_BANNER, SHOW_BANNER } from './constants';
import { combineReducers } from 'redux';

const bannerType = (state = null, action) => {
    switch (action.type) {
        case SHOW_BANNER:
            return action.bannerType || null;
        case HIDE_BANNER:
            return null;
        default:
            return state;
    }
};

const bannerProps = (state = null, action) => {
    switch (action.type) {
        case SHOW_BANNER:
            return action.bannerProps || null;
        case HIDE_BANNER:
            return null;
        default:
            return state;
    }
};

export default combineReducers({ bannerType, bannerProps });



// WEBPACK FOOTER //
// ./src/services/banner/reducer.js